<digital-platform-icon
  [icon]="svgIconClass?.iconClass ?? ''"
  [size]="iconSize?.name ?? ''"
  data-automation-id="svg-icon-container"
></digital-platform-icon>
